document.addEventListener('DOMContentLoaded', function () {
  initMobileFilterDrawer();
  initMobilePriceSlider();
  initTdgPriceRangeCheckboxes();
});

function initMobileFilterDrawer() {
  const body = document.body;
  const openBtn = document.querySelector('.tdg-mobile-filter-toggle');
  const closeBtn = document.querySelector('.tdg-mobile-filter-close');
  const overlay = document.querySelector('.tdg-mobile-filter-overlay');
  const applyBtn = document.querySelector('.tdg-mobile-filter-apply');
  const drawer = document.querySelector('.tdg-mobile-filter-drawer');

  if (!openBtn || !drawer) return;

  function openDrawer() {
    body.classList.add('tdg-mobile-filter-open');
    openBtn.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    body.classList.remove('tdg-mobile-filter-open');
    openBtn.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
  }

  openBtn.addEventListener('click', openDrawer);

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      setTimeout(closeDrawer, 100);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });
}

function initMobilePriceSlider() {
  const priceVisual = document.querySelector('.tdg-mobile-price-visual');
  if (!priceVisual) return;

  const track = priceVisual.querySelector('.tdg-mobile-price-visual__track');
  const range = priceVisual.querySelector('.tdg-mobile-price-visual__range');
  const leftDot = priceVisual.querySelector('.tdg-mobile-price-visual__dot--left');
  const rightDot = priceVisual.querySelector('.tdg-mobile-price-visual__dot--right');

  const topLeft = priceVisual.querySelector('.tdg-mobile-price-visual__top--left');
  const topRight = priceVisual.querySelector('.tdg-mobile-price-visual__top--right');

  const hiddenMin = document.querySelector('.tdg-mobile-price-hidden-min');
  const hiddenMax = document.querySelector('.tdg-mobile-price-hidden-max');

  if (!track || !range || !leftDot || !rightDot || !hiddenMin || !hiddenMax) return;

  const min = Number(priceVisual.dataset.min || 0);
  const max = Number(priceVisual.dataset.max || 100000);
  let currentMin = Number(priceVisual.dataset.startMin || 15000);
  let currentMax = Number(priceVisual.dataset.startMax || 60000);

  function formatINR(value) {
    return '₹' + Number(value).toLocaleString('en-IN');
  }

  function clamp(value, minVal, maxVal) {
    return Math.min(Math.max(value, minVal), maxVal);
  }

  function valueToPercent(value) {
    return ((value - min) / (max - min)) * 100;
  }

  function percentToValue(percent) {
    return Math.round(min + ((max - min) * percent) / 100);
  }

  function render() {
    const leftPercent = valueToPercent(currentMin);
    const rightPercent = valueToPercent(currentMax);

    leftDot.style.left = `calc(${leftPercent}% - 9px)`;
    rightDot.style.left = `calc(${rightPercent}% - 9px)`;

    range.style.left = `${leftPercent}%`;
    range.style.right = `${100 - rightPercent}%`;

    topLeft.textContent = formatINR(currentMin);
    topRight.textContent = formatINR(currentMax);

    topLeft.style.left = `${leftPercent}%`;
    topRight.style.left = `${rightPercent}%`;

    hiddenMin.value = currentMin;
    hiddenMax.value = currentMax;

    syncPriceCheckboxes(currentMin, currentMax);
  }

  function startDrag(dotType, event) {
    event.preventDefault();

    const move = (clientX) => {
      const rect = track.getBoundingClientRect();
      let percent = ((clientX - rect.left) / rect.width) * 100;
      percent = clamp(percent, 0, 100);

      const value = percentToValue(percent);

      if (dotType === 'left') {
        currentMin = clamp(value, min, currentMax - 1000);
      } else {
        currentMax = clamp(value, currentMin + 1000, max);
      }

      render();
    };

    const onMouseMove = (e) => move(e.clientX);
    const onTouchMove = (e) => {
      if (e.touches[0]) move(e.touches[0].clientX);
    };

    const stop = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', stop);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', stop);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', stop);
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', stop);
  }

  leftDot.addEventListener('mousedown', (e) => startDrag('left', e));
  rightDot.addEventListener('mousedown', (e) => startDrag('right', e));

  leftDot.addEventListener('touchstart', (e) => startDrag('left', e), { passive: false });
  rightDot.addEventListener('touchstart', (e) => startDrag('right', e), { passive: false });

  render();
}

function initTdgPriceRangeCheckboxes() {
  const hiddenMin = document.querySelector('.tdg-mobile-price-hidden-min');
  const hiddenMax = document.querySelector('.tdg-mobile-price-hidden-max');
  const visual = document.querySelector('.tdg-mobile-price-visual');
  const checkboxes = document.querySelectorAll('.tdg-price-range-checkbox');

  if (!hiddenMin || !hiddenMax || !visual || !checkboxes.length) return;

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      if (this.checked) {
        checkboxes.forEach((cb) => {
          if (cb !== this) cb.checked = false;
        });

        const min = parseInt(this.dataset.min || 0, 10);
        const max = parseInt(this.dataset.max || 100000, 10);

        hiddenMin.value = min;
        hiddenMax.value = max;

        updateTdgPriceVisual(min, max);
      } else {
        hiddenMin.value = 15000;
        hiddenMax.value = 60000;
        updateTdgPriceVisual(15000, 60000);
      }
    });
  });

  syncPriceCheckboxesOnLoad();
}

function updateTdgPriceVisual(min, max) {
  const visual = document.querySelector('.tdg-mobile-price-visual');
  if (!visual) return;

  const range = visual.querySelector('.tdg-mobile-price-visual__range');
  const leftDot = visual.querySelector('.tdg-mobile-price-visual__dot--left');
  const rightDot = visual.querySelector('.tdg-mobile-price-visual__dot--right');
  const topLeft = visual.querySelector('.tdg-mobile-price-visual__top--left');
  const topRight = visual.querySelector('.tdg-mobile-price-visual__top--right');

  const totalMin = parseInt(visual.dataset.min || 0, 10);
  const totalMax = parseInt(visual.dataset.max || 100000, 10);

  const leftPercent = ((min - totalMin) / (totalMax - totalMin)) * 100;
  const rightPercent = ((max - totalMin) / (totalMax - totalMin)) * 100;

  if (leftDot) leftDot.style.left = `calc(${leftPercent}% - 9px)`;
  if (rightDot) rightDot.style.left = `calc(${rightPercent}% - 9px)`;

  if (range) {
    range.style.left = `${leftPercent}%`;
    range.style.right = `${100 - rightPercent}%`;
  }

  if (topLeft) topLeft.textContent = formatTdgMoney(min);
  if (topRight) topRight.textContent = formatTdgMoney(max);

  if (topLeft) topLeft.style.left = `${leftPercent}%`;
  if (topRight) topRight.style.left = `${rightPercent}%`;

  syncPriceCheckboxes(min, max);
}

function syncPriceCheckboxesOnLoad() {
  const hiddenMin = document.querySelector('.tdg-mobile-price-hidden-min');
  const hiddenMax = document.querySelector('.tdg-mobile-price-hidden-max');

  if (!hiddenMin || !hiddenMax) return;

  const min = parseInt(hiddenMin.value || 15000, 10);
  const max = parseInt(hiddenMax.value || 60000, 10);

  syncPriceCheckboxes(min, max);
}

function syncPriceCheckboxes(min, max) {
  const checkboxes = document.querySelectorAll('.tdg-price-range-checkbox');
  if (!checkboxes.length) return;

  checkboxes.forEach((checkbox) => {
    const cbMin = parseInt(checkbox.dataset.min || 0, 10);
    const cbMax = parseInt(checkbox.dataset.max || 100000, 10);

    checkbox.checked = cbMin === min && cbMax === max;
  });
}

function formatTdgMoney(value) {
  return `₹${Number(value).toLocaleString('en-IN')}`;
}

document.addEventListener('DOMContentLoaded', function () {
  initDesktopPriceSlider();
  initDesktopPriceRangeCheckboxes();
});

function initDesktopPriceSlider() {
  const priceVisual = document.querySelector('.tdg-desktop-price-visual');
  if (!priceVisual) return;

  const track = priceVisual.querySelector('.tdg-desktop-price-visual__track');
  const range = priceVisual.querySelector('.tdg-desktop-price-visual__range');
  const leftDot = priceVisual.querySelector('.tdg-desktop-price-visual__dot--left');
  const rightDot = priceVisual.querySelector('.tdg-desktop-price-visual__dot--right');

  const topLeft = priceVisual.querySelector('.tdg-desktop-price-visual__top--left');
  const topRight = priceVisual.querySelector('.tdg-desktop-price-visual__top--right');

  const hiddenMin = document.querySelector('.tdg-desktop-price-hidden-min');
  const hiddenMax = document.querySelector('.tdg-desktop-price-hidden-max');

  if (!track || !range || !leftDot || !rightDot || !hiddenMin || !hiddenMax) return;

  const min = Number(priceVisual.dataset.min || 0);
  const max = Number(priceVisual.dataset.max || 100000);
  let currentMin = Number(priceVisual.dataset.startMin || 15000);
  let currentMax = Number(priceVisual.dataset.startMax || 60000);

  function clamp(value, minVal, maxVal) {
    return Math.min(Math.max(value, minVal), maxVal);
  }

  function valueToPercent(value) {
    return ((value - min) / (max - min)) * 100;
  }

  function percentToValue(percent) {
    return Math.round(min + ((max - min) * percent) / 100);
  }

  function render() {
    const leftPercent = valueToPercent(currentMin);
    const rightPercent = valueToPercent(currentMax);

    leftDot.style.left = `calc(${leftPercent}% - 9px)`;
    rightDot.style.left = `calc(${rightPercent}% - 9px)`;

    range.style.left = `${leftPercent}%`;
    range.style.right = `${100 - rightPercent}%`;

    if (topLeft) topLeft.textContent = formatTdgMoney(currentMin);
    if (topRight) topRight.textContent = formatTdgMoney(currentMax);

    if (topLeft) topLeft.style.left = `${leftPercent}%`;
    if (topRight) topRight.style.left = `${rightPercent}%`;

    hiddenMin.value = currentMin;
    hiddenMax.value = currentMax;

    syncDesktopPriceCheckboxes(currentMin, currentMax);
  }

  function startDrag(dotType, event) {
    event.preventDefault();

    const move = (clientX) => {
      const rect = track.getBoundingClientRect();
      let percent = ((clientX - rect.left) / rect.width) * 100;
      percent = clamp(percent, 0, 100);

      const value = percentToValue(percent);

      if (dotType === 'left') {
        currentMin = clamp(value, min, currentMax - 1000);
      } else {
        currentMax = clamp(value, currentMin + 1000, max);
      }

      render();
    };

    const onMouseMove = (e) => move(e.clientX);
    const onTouchMove = (e) => {
      if (e.touches[0]) move(e.touches[0].clientX);
    };

    const stop = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', stop);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', stop);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', stop);
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', stop);
  }

  leftDot.addEventListener('mousedown', (e) => startDrag('left', e));
  rightDot.addEventListener('mousedown', (e) => startDrag('right', e));
  leftDot.addEventListener('touchstart', (e) => startDrag('left', e), { passive: false });
  rightDot.addEventListener('touchstart', (e) => startDrag('right', e), { passive: false });

  render();
}

function initDesktopPriceRangeCheckboxes() {
  const hiddenMin = document.querySelector('.tdg-desktop-price-hidden-min');
  const hiddenMax = document.querySelector('.tdg-desktop-price-hidden-max');
  const checkboxes = document.querySelectorAll('.tdg-desktop-price-range-checkbox');

  if (!hiddenMin || !hiddenMax || !checkboxes.length) return;

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      if (this.checked) {
        checkboxes.forEach((cb) => {
          if (cb !== this) cb.checked = false;
        });

        const min = parseInt(this.dataset.min || 0, 10);
        const max = parseInt(this.dataset.max || 100000, 10);

        hiddenMin.value = min;
        hiddenMax.value = max;

        updateDesktopPriceVisual(min, max);
      } else {
        hiddenMin.value = 15000;
        hiddenMax.value = 60000;
        updateDesktopPriceVisual(15000, 60000);
      }
    });
  });

  syncDesktopPriceCheckboxesOnLoad();
}

function updateDesktopPriceVisual(min, max) {
  const visual = document.querySelector('.tdg-desktop-price-visual');
  if (!visual) return;

  const range = visual.querySelector('.tdg-desktop-price-visual__range');
  const leftDot = visual.querySelector('.tdg-desktop-price-visual__dot--left');
  const rightDot = visual.querySelector('.tdg-desktop-price-visual__dot--right');
  const topLeft = visual.querySelector('.tdg-desktop-price-visual__top--left');
  const topRight = visual.querySelector('.tdg-desktop-price-visual__top--right');

  const totalMin = parseInt(visual.dataset.min || 0, 10);
  const totalMax = parseInt(visual.dataset.max || 100000, 10);

  const leftPercent = ((min - totalMin) / (totalMax - totalMin)) * 100;
  const rightPercent = ((max - totalMin) / (totalMax - totalMin)) * 100;

  if (leftDot) leftDot.style.left = `calc(${leftPercent}% - 9px)`;
  if (rightDot) rightDot.style.left = `calc(${rightPercent}% - 9px)`;

  if (range) {
    range.style.left = `${leftPercent}%`;
    range.style.right = `${100 - rightPercent}%`;
  }

  if (topLeft) topLeft.textContent = formatTdgMoney(min);
  if (topRight) topRight.textContent = formatTdgMoney(max);

  if (topLeft) topLeft.style.left = `${leftPercent}%`;
  if (topRight) topRight.style.left = `${rightPercent}%`;

  syncDesktopPriceCheckboxes(min, max);
}

function syncDesktopPriceCheckboxesOnLoad() {
  const hiddenMin = document.querySelector('.tdg-desktop-price-hidden-min');
  const hiddenMax = document.querySelector('.tdg-desktop-price-hidden-max');

  if (!hiddenMin || !hiddenMax) return;

  const min = parseInt(hiddenMin.value || 15000, 10);
  const max = parseInt(hiddenMax.value || 60000, 10);

  syncDesktopPriceCheckboxes(min, max);
}

function syncDesktopPriceCheckboxes(min, max) {
  const checkboxes = document.querySelectorAll('.tdg-desktop-price-range-checkbox');
  if (!checkboxes.length) return;

  checkboxes.forEach((checkbox) => {
    const cbMin = parseInt(checkbox.dataset.min || 0, 10);
    const cbMax = parseInt(checkbox.dataset.max || 100000, 10);
    checkbox.checked = cbMin === min && cbMax === max;
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initDesktopFacetAutosubmit();
});

function initDesktopFacetAutosubmit() {
  const desktopForm = document.querySelector('#tdg-desktop-facets-form');
  if (!desktopForm) return;

  const normalCheckboxes = desktopForm.querySelectorAll(
    '.tdg-filter-checkbox input[type="checkbox"]:not(.tdg-desktop-price-range-checkbox)'
  );

  normalCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      desktopForm.requestSubmit();
    });
  });

  const desktopPriceCheckboxes = desktopForm.querySelectorAll('.tdg-desktop-price-range-checkbox');
  desktopPriceCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      setTimeout(() => desktopForm.requestSubmit(), 50);
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initAjaxCollectionFilters();
});

function initAjaxCollectionFilters() {
  const desktopForm = document.querySelector('#tdg-desktop-facets-form');
  const mobileForm = document.querySelector('#tdg-mobile-facets-form');

  if (desktopForm) {
    bindAjaxFilterForm(desktopForm);
  }

  if (mobileForm) {
    bindAjaxFilterForm(mobileForm);
  }

  bindAjaxFilterLinks();
}

function bindAjaxFilterForm(form) {
  const checkboxes = form.querySelectorAll('input[type="checkbox"]');
  const hiddenInputs = form.querySelectorAll('input[type="hidden"]');
  const applyBtn = document.querySelector('.tdg-mobile-filter-apply');

  checkboxes.forEach((input) => {
    input.addEventListener('change', function () {
      if (form.id === 'tdg-desktop-facets-form') {
        applyAjaxFilters(form);
      }
    });
  });

  hiddenInputs.forEach((input) => {
    input.addEventListener('change', function () {
      if (form.id === 'tdg-desktop-facets-form') {
        applyAjaxFilters(form);
      }
    });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    applyAjaxFilters(form);
  });

  if (applyBtn && form.id === 'tdg-mobile-facets-form') {
    applyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      applyAjaxFilters(form);
    });
  }
}

function applyAjaxFilters(form) {
  const page = document.querySelector('.tdg-collection-page');
  if (!page) return;

  const formData = new FormData(form);
  const params = new URLSearchParams();

  for (const [key, value] of formData.entries()) {
    if (value !== '' && value != null) {
      params.append(key, value);
    }
  }

  const baseUrl = window.location.pathname;
  const nextUrl = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;

  page.classList.add('is-filter-loading');

  fetch(nextUrl, {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newContent = doc.querySelector('#tdg-collection-content');
      const currentContent = document.querySelector('#tdg-collection-content');

      const newDesktopChips = doc.querySelector('#tdg-desktop-active-filters');
      const currentDesktopChips = document.querySelector('#tdg-desktop-active-filters');

      const newMobileChips = doc.querySelector('#tdg-mobile-active-filters');
      const currentMobileChips = document.querySelector('#tdg-mobile-active-filters');

      const newDesktopForm = doc.querySelector('#tdg-desktop-facets-form');
      const currentDesktopForm = document.querySelector('#tdg-desktop-facets-form');

      const newMobileForm = doc.querySelector('#tdg-mobile-facets-form');
      const currentMobileForm = document.querySelector('#tdg-mobile-facets-form');

      if (newContent && currentContent) {
        currentContent.innerHTML = newContent.innerHTML;
      }

      if (newDesktopForm && currentDesktopForm) {
        currentDesktopForm.innerHTML = newDesktopForm.innerHTML;
      }

      if (newMobileForm && currentMobileForm) {
        currentMobileForm.innerHTML = newMobileForm.innerHTML;
      }

      if (newDesktopChips && currentDesktopChips) {
        currentDesktopChips.outerHTML = newDesktopChips.outerHTML;
      } else if (!newDesktopChips && currentDesktopChips) {
        currentDesktopChips.remove();
      }

      if (newMobileChips && currentMobileChips) {
        currentMobileChips.outerHTML = newMobileChips.outerHTML;
      } else if (!newMobileChips && currentMobileChips) {
        currentMobileChips.remove();
      }

      window.history.pushState({}, '', nextUrl);

      reInitCollectionScripts();
    })
    .catch((error) => {
      console.error('Filter AJAX error:', error);
      window.location.href = nextUrl;
    })
    .finally(() => {
      page.classList.remove('is-filter-loading');
    });
}

function bindAjaxFilterLinks() {
  document.addEventListener('click', function (e) {
    const link = e.target.closest(
      '.tdg-desktop-filter-chip, .tdg-desktop-filter-clear-all, .tdg-mobile-filter-chip, .tdg-mobile-filter-clear-all'
    );

    if (!link) return;

    e.preventDefault();

    const page = document.querySelector('.tdg-collection-page');
    if (!page) return;

    const nextUrl = link.getAttribute('href');
    if (!nextUrl) return;

    page.classList.add('is-filter-loading');

    fetch(nextUrl, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newContent = doc.querySelector('#tdg-collection-content');
        const currentContent = document.querySelector('#tdg-collection-content');

        const newDesktopChips = doc.querySelector('#tdg-desktop-active-filters');
        const currentDesktopChips = document.querySelector('#tdg-desktop-active-filters');

        const newMobileChips = doc.querySelector('#tdg-mobile-active-filters');
        const currentMobileChips = document.querySelector('#tdg-mobile-active-filters');

        const newDesktopForm = doc.querySelector('#tdg-desktop-facets-form');
        const currentDesktopForm = document.querySelector('#tdg-desktop-facets-form');

        const newMobileForm = doc.querySelector('#tdg-mobile-facets-form');
        const currentMobileForm = document.querySelector('#tdg-mobile-facets-form');

        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }

        if (newDesktopForm && currentDesktopForm) {
          currentDesktopForm.innerHTML = newDesktopForm.innerHTML;
        }

        if (newMobileForm && currentMobileForm) {
          currentMobileForm.innerHTML = newMobileForm.innerHTML;
        }

        if (newDesktopChips && currentDesktopChips) {
          currentDesktopChips.outerHTML = newDesktopChips.outerHTML;
        } else if (!newDesktopChips && currentDesktopChips) {
          currentDesktopChips.remove();
        }

        if (newMobileChips && currentMobileChips) {
          currentMobileChips.outerHTML = newMobileChips.outerHTML;
        } else if (!newMobileChips && currentMobileChips) {
          currentMobileChips.remove();
        }

        window.history.pushState({}, '', nextUrl);

        reInitCollectionScripts();
      })
      .catch((error) => {
        console.error('Chip AJAX error:', error);
        window.location.href = nextUrl;
      })
      .finally(() => {
        page.classList.remove('is-filter-loading');
      });
  });
}

function reInitCollectionScripts() {
  initMobilePriceSlider();
  initTdgPriceRangeCheckboxes();
  initDesktopPriceSlider();
  initDesktopPriceRangeCheckboxes();
  initDesktopFacetAutosubmit();
  initAjaxCollectionFilters();
}


document.addEventListener('DOMContentLoaded', function () {
  initTdgAddToCartAjax();
});
function initTdgAddToCartAjax() {
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.tdg-handpicked__btn-ajax');
    if (!button) return;
    event.preventDefault();
    if (window.openTuduguSizeDrawer) {
      window.openTuduguSizeDrawer(button, event);
      return;
    }
    if (button.classList.contains('is-adding')) return;
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const quantityInput = button.closest('product-info')?.querySelector('[name="quantity"]') || button.closest('form')?.querySelector('[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    button.classList.add('is-adding');
    const textSpan = button.querySelector('.tdg-handpicked__button-text');
    if (textSpan) {
      textSpan.textContent = 'ADDING...';
    }
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: quantity }]
        })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Unable to add product');
      }
      button.classList.remove('is-adding');
      button.classList.add('is-added');
      button.setAttribute('data-state', 'go-to-cart');
      if (textSpan) {
        textSpan.textContent = 'GO TO CART';
      }
      button.setAttribute('href', window.routes?.cart_url || '/cart');
      const toast = document.querySelector('.tdg-handpicked__toast');
      if (toast) {
        toast.textContent = 'Product added to cart';
        toast.classList.add('is-visible');
        if (window.tdgToastTimer) clearTimeout(window.tdgToastTimer);
        window.tdgToastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    } catch (error) {
      console.error(error);
      alert(error.message || 'Unable to add product');
      button.classList.remove('is-adding');
      if (textSpan) {
        textSpan.textContent = 'Add To Cart';
      }
    }
  });
}